// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"482":"fa5a2182","567":"9327f00f","651":"6c13ece3"}[chunkId] + ".chunk.js";
};